import { useMFEContext } from '~/components/MFEProvider';

import useFeature from './useFeature';

const useNovaEnabled = () => {
  // @ts-expect-error
  const { brandFromJWT } = useMFEContext();
  const isBlueHost = brandFromJWT.toLowerCase() === 'bluehost';
  const isHostgator = brandFromJWT.toLowerCase() === 'hostgator';
  const [isCloudHosting] = useFeature('atomic');

  return { isNovaEnabled: (isBlueHost || isHostgator) && !isCloudHosting };
};
export default useNovaEnabled;
